import { Row } from "antd";
import styled from "styled-components";

export const FullEngineerInfoWrapper = styled(Row)<{ $iconColor: string }>`
  > .ant-col .anticon {
    display: flex;
    align-items: center;
    height: 24px;

    svg {
      height: 16px;
      width: 16px;
    }
  }

  > .ant-col:first-child > .anticon > svg {
    path {
      color: ${(props) => props.$iconColor};
    }

    path:nth-child(2) {
      stroke: ${(props) => props.$iconColor};
    }
  }

  .engineer-item-text-col {
    max-width: 284px;

    .ant-typography {
      line-height: 24px;
    }

    .ant-typography:first-child {
      color: ${(props) => props.$iconColor};
    }

    .ant-typography:last-child {
      color: ${"#bfbfbf"};
    }
  }
`;
